export default __webpack_public_path__ + "static/media/ISEO CLASS-3 EXAM PATTERN 2025.f6edae32.pdf";